document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-view-dimensions]');
  if (!trigger) return;

  const sectionId = trigger.dataset.sectionId;
  const thumbnails = document.getElementById(`GalleryThumbnails-${sectionId}`);
  if (!thumbnails) return;

  const dimensionsImg = Array.from(thumbnails.querySelectorAll('img')).find(
    (img) => img.alt && img.alt.includes('Dimensions') && img.closest('li').style.display !== 'none'
  );
  if (!dimensionsImg) return;

  const button = dimensionsImg.closest('button');
  const gallery = document.getElementById(`MediaGallery-${sectionId}`);

  if (gallery) {
    gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  if (button) {
    setTimeout(() => button.click(), 300);
  }
});
